import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;
const Main = styled.main<{ sidebarOpen: boolean }>`
  flex: 1;
  background: #f7f8fa;
  padding: 2rem 2.5rem;
  margin-left: ${({ sidebarOpen }) => (sidebarOpen ? '250px' : '70px')};
  transition: margin-left 0.3s cubic-bezier(0.4,0,0.2,1);
`;

const AccountantLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((open) => !open);
  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Navbar toggleSidebar={toggleSidebar} />
        <Main sidebarOpen={sidebarOpen}>
          <Outlet />
        </Main>
      </div>
    </LayoutContainer>
  );
};

export default AccountantLayout; 